import styled, { css } from "styled-components";
import {
  Menu as MenuMaterialUI,
  MenuItem as MenuItemMaterial,
} from "@material-ui/core";

export const SubMenuItem = styled(MenuItemMaterial)`
  font-weight: normal;
`;

export const ArrowMenu = styled.div`
  position: relative;
  overflow: hidden;
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  background: #fff;
  transform: rotate(45deg);
  border: solid 1px #000;

  ${(props) => {
    const anchorEl = props.anchorEl;

    return (
      anchorEl &&
      css`
        position: fixed;
        top: ${anchorEl.clientHeight + 14}px;
        left: ${anchorEl.offsetLeft + 20}px;
      `
    );
  }}
`;
